<template>
  <div class="wrapper">
    <!--地图-->
    <div id="map" class="map">
      <a-button v-if="redrawShape" style="position: absolute; top: 10px; right: 10px; z-index: 100" @click="reDraw(drawType)">
        重新绘制
      </a-button>
    </div>
  </div>
</template>

<script>
  import { bus } from '@/bus.js' //引入bus.js定义的空的Vue实例
  import Map from 'ol/Map'
  import View from 'ol/View'
    import { Polygon, LineString, MultiPolygon } from 'ol/geom'
  import { Style, Fill, Stroke, Circle, Text, Circle as CircleStyle, Icon } from 'ol/style'
  import { Draw, Select, Modify as iModify, DragBox, DoubleClickZoom, defaults as Idefaults } from 'ol/interaction'
  import { ScaleLine, MousePosition, defaults } from 'ol/control'
  import { fromLonLat, toLonLat, get as projGet, getPointResolution } from 'ol/proj'
  import { createEmpty, extend, getWidth, getHeight, getCenter ,getTopLeft,getBottomLeft} from 'ol/extent'
  import { GeoJSON, WFS, WMSCapabilities, WMTSCapabilities, WMSGetFeatureInfo,MVT } from 'ol/format'
  import {createBox,createRegularPolygon} from 'ol/interaction/Draw';
  
  import xml2Json from 'xml-js'//xml和json互转插件
  import { XYZ, OSM, Vector, ImageArcGISRest, TileArcGISRest, TileWMS, Cluster, ImageWMS, VectorTile,WMTS } from 'ol/source'
import { Tile, WebGLTile,Group, Image, Vector as lVector, VectorTile as lVectorTile } from 'ol/layer'
import TileGrid from 'ol/tilegrid/TileGrid'
import WMTSTileGrid from 'ol/tilegrid/WMTS'
import { createXYZ } from 'ol/tilegrid'
import {ParseLayer} from './ParseLayer'  //更具url解译然后加载



  export default {
    name: "SmallMap",
    mixins: [ParseLayer],
    props:{
      drawType: {
        type: String,
        default: 'None'
      },
      placeGeoJSON:{
        type: String,
        default: ''
      }
    },
    data(){
      return{
        map:null,
        source:null,
        draw:null,
        taskDrawLayer: {},//用于渔网的图层
        taskDrawVector: {},//fishnetLayer图层的源
        taskDrawStyle: {},//fishnetLayer图层的style
        redrawShape:false,
        inputUrl: "",//绘制的url
        featureTypesForAttr: [],//属性
        isOutNet:true,
        mapParams:{
            projection:'EPSG:3857', //注意：必须加上此投影才能显示地图，目前有效的是4326和3857，而4490暂未生效
            center:[108.29883, 35.72902], //地图初始化时的中心坐标【基于4326坐标系】
            // center:[127.87535, 43.58279], //地图初始化时的中心坐标【基于4326坐标系】--吉林省
            // center:[14043866.93127, 5478150.09276], //地图初始化时的中心坐标【基于3857坐标系】
            // mExtent:[120.45536,35.55856,139.36943,44.78707], //左下点-右上点
            minZoom:4, //可以缩小的最小级别；若此处未定义，地图接收到undefined则表示不受限制
            maxZoom:22, //可以放大的最大级别；若此处未定义，地图接收到undefined则表示不受限制
            zoom:5, //地图初始化时显示级别；注意：若此处未定义，地图初始化显示不出来
        },

        tifExtent:[],
        

      }
    },
    watch:{
        tifExtent(){
            bus.$emit('extentGet',this.tifExtent)
        }
    },
    created(){
//         this.axios({url:'https://restapi.amap.com/v3/weather/weatherInfo?city=110101&key=fb18cbd4fb7f9350598e5925e15a3f96&extensions=all',timeout:500}).then(res=>{
// //当前是外网
// this.isOutNet=true;
//             this.geoserverAuth = {
//                 username: 'admin',
//                 password: 'Sjss_Cgwx!@34'
//                 //password: 'geoserver'
//             }
// }).catch(error=>{
//             //当前是内网
//             this.isOutNet=false;
//             this.geoserverAuth = {
//                 username: 'admin',
//                 password: '123!@#'
//             }
// })
        setTimeout(() => {
          //当前是外网
            this.isOutNet=true;
            this.geoserverAuth = {
                username: 'admin',
                password: 'Sjys_Cgwx!@34'
                //password: 'geoserver'
            }
        },500)
    },
    mounted(){
        bus.$off('removeUrlToMap');
        bus.$on('removeUrlToMap',this.removeUrlToMapRe);
        bus.$off('addUrlToMap');
        bus.$on('addUrlToMap',this.addUrlToMapRe);

        bus.$off('addUrlToMap2');
        bus.$on('addUrlToMap2',this.addUrlToMapRe2);

        bus.$off('addToDraw');
        bus.$on('addToDraw',this.extentDraw);
      
    },
    methods:{

      async initMap(){
        await this.initMapFirst();
        //默认刷新  适配地图  避免地图cavans与地理坐标不匹配
      this.map.updateSize();
      },
      async initMapFirst(){
        let view = new View({
          center: fromLonLat([108.29883, 35.72902]),
          zoom:6,
          maxZoom:18,
          minZoom:2
        });

        let osm = new Tile({
          source: new OSM()
        });
        let layerOrigin = new Tile({
            name: '天地图矢量图层',
            title: '天地图矢量图层',
            //arcgis
            source: new TileArcGISRest({
            crossOrigin: 'anonymous',
            url: 'https://map.geoq.cn/ArcGIS/rest/services/ChinaOnlineStreetGray/MapServer',
            // url: "https://map.geoq.cn/ArcGIS/rest/services/ChinaOnlineCommunity/MapServer",  //信息密集一些
            }),

        });
        let yizhangtu = new Tile({
            name: '全国一张图',
            title: '全国一张图',
            //arcgis
            source: new XYZ({
                crossOrigin: 'anonymous',
                url: 'https://tile.charmingglobe.com/tile/china2022/tms/{z}/{x}/{-y}?v=v1&token=Bearer bc5bb178739745ebac0643579295202a',
            // url: "https://map.geoq.cn/ArcGIS/rest/services/ChinaOnlineCommunity/MapServer",  //信息密集一些
            }),

        });

        //标注图层
        let styles = {
          'Point': new Style({
            image: new CircleStyle({
              radius: 5,
              fill: new Fill({
                color: 'rgba(0, 0, 255, 0.5)',
              }),
              stroke: new Stroke({color: 'blue', width: 1}),
            })
            // image: new Icon({
            //   src: require('@/assets/point.png')
            // })
          }),
          'Polygon': new Style({
            stroke: new Stroke({
              color: 'blue',
              width: 1,
            }),
            fill: new Fill({
              color: 'rgba(0, 0, 255, 0.1)',
            }),
          })
        }

        let styleFunction = function (feature) {
          return styles[feature.getGeometry().getType()];
        };

        this.source = new Vector({ wrapX: false });

        let vector = new lVector({
          source: this.source,
          zIndex:100,
          style: styleFunction,
        });

        this.map = new Map({
            controls: defaults({
                    zoom: false,
                    rotate: false,
                    attribution: false,
                  }), //默认不显示缩放控件
          interactions: Idefaults({
            doubleClickZoom: false // 取消双击放大功能交互
            //mouseWheelZoom: false, // 取消滚动鼠标中间的滑轮交互
            //shiftDragZoom: false, // 取消shift+wheel左键拖动交互
          }),
          layers: [layerOrigin,vector],
          target: 'map',
          view: view
        });

      },
      addUrlToMapRe(valueTitle,valueUrl,valueExt){
        let that = this
        let ext = valueExt.split(',')
        ext = [parseFloat(ext[0]),parseFloat(ext[1]),parseFloat(ext[2]),parseFloat(ext[3])]
        let layer = that.ParseLayer({title:valueTitle +'yulan',url:valueUrl});
        that.map.getLayers().forEach(layer => {
            if(/yulan/.test(layer.values_.title)){
                that.map.removeLayer(layer);//删除除了osm外的图层
            }
        })
        //内网先移除全部图层
        // if(!that.isOutNet){
        //     that.map.getLayers().forEach(layer => {
        //         that.map.removeLayer(layer);//删除除了osm外的图层
        //     })
        // }
        let tmpLyrs = that.addLyr4init(layer);
        tmpLyrs.then(v => {
            v.forEach(value => {
                that.map.addLayer(value)
                ext = that.changeBboxFromLonLat(ext);
                // that.map.getView().fit(ext)
                that.zoomToExtent(value);
            })
        });
      },
      addUrlToMapRe2(valueTitle,valueUrl,qianhou){
        let that = this;
        let layer = that.ParseLayer({title:valueTitle +qianhou,url:valueUrl});
        let reg = new RegExp(qianhou);
        //清空绘画的内容
        let layerArr = that.map.getLayers().array_;
        //删除元素的时候要从后开始删除，要不然会删除错误，主要不会再从第一个删除而且长度也会变化
        for (let i = layerArr.length - 1; i >= 0; i--) {
            if (reg.test(layerArr[i].values_.title)) {
                that.map.removeLayer(layerArr[i]);
            }
        }
        //内网先移除全部图层
        // if(!that.isOutNet){
        //     that.map.getLayers().forEach(layer => {
        //         that.map.removeLayer(layer);//删除除了osm外的图层
        //     })
        // }
        let tmpLyrs = that.addLyr4init(layer);
        tmpLyrs.then(v => {
            v.forEach(value => {
                that.map.addLayer(value)
                that.zoomToExtent(value);
            })
        });
      },
      removeUrlToMapRe(){
        let that = this;
        that.map.getLayers().forEach(layer => {
          if(!(layer.getSource().urls)){
            that.map.removeLayer(layer);//删除除了osm外的图层
          }
        })
      },
      //添加图层
      async addLyr4init({ lyrType, srcType, mUrl, mTitle, mName, mVisible, mExtent, mSubLayers, mKey, mProductDate }) {
            let that = this;
            if (!(lyrType === 'Group') && mUrl) {
                mUrl = mUrl.replace('121.36.101.27:3001', '121.36.101.27:3000');
                mUrl = mUrl.replace('121.36.101.27:8081', '121.36.101.27:8080');
                if (!(that.isOutNet)) {
                    mUrl = mUrl.replace('121.36.71.163', '192.168.1.176');
                    mUrl = mUrl.replace('121.36.101.27', '192.168.103.72');
                    mUrl = mUrl.replace('119.3.163.125', '192.168.1.31'); //德清
                    mUrl = mUrl.replace('https://map.charmingglobe.com', 'http://192.168.1.176:3000');
                    mUrl = mUrl.replace('https://tile.charmingglobe.com', 'http://192.168.1.10');
                }
            }
            //以下部分用于设置集群的样式及半径大小的计算
            let maxFeatureCount
            let calculateClusterInfo = function (resolution) {
                maxFeatureCount = 0
                let features = lyr.getSource().getFeatures()
                let feature, radius
                for (let i = features.length - 1; i >= 0; --i) {
                    feature = features[i]
                    let originalFeatures = feature.get('features')
                    let extent = createEmpty()
                    let j = void 0,
                        jj = void 0
                    for (j = 0, jj = originalFeatures.length; j < jj; ++j) {
                        extend(extent, originalFeatures[j].getGeometry().getExtent())
                    }
                    maxFeatureCount = Math.max(maxFeatureCount, jj)
                    /* radius = 0.025 * (getWidth(extent) + getHeight(extent)) /
                        resolution; */
                    feature.set('radius', 1)
                }
            }

            let currentResolution
            function styleFunction(feature, resolution) {
                if (resolution != currentResolution) {
                    calculateClusterInfo(resolution)
                    currentResolution = resolution
                }
                let style
                if (feature.get('features')) {
                    let size = feature.get('features').length
                    if (size >= 1) {
                        style = new Style({
                            image: new CircleStyle({
                                radius: feature.get('radius'),
                                fill: new Fill({
                                    color: [255, 153, 0, Math.min(0.8, 0.4 + size / maxFeatureCount)]
                                })
                            }),
                            text: new Text({
                                text: size.toString(),
                                fill: new Fill({
                                    color: '#fff'
                                }),
                                stroke: new Stroke({
                                    color: 'rgba(0, 0, 0, 0.6)',
                                    width: 3
                                }),
                                font: '20px sans-serif'
                            })
                        })
                    } else {
                        // var originalFeature = feature.get('features')[0];
                        // style = createEarthquakeStyle(originalFeature);
                        style = null //没啥用
                    }
                }
                return style
            }
            //以上部分用于设置集群的样式及半径大小的计算

            function vectorLoader(extent, resolution, projection) {
                let this1 = this;
                var proj = projection.getCode()
                var url = mUrl
                var xhr = new XMLHttpRequest()
                xhr.open('GET', url)
                var onError = function () {
                    this1.removeLoadedExtent(extent)
                }
                xhr.onerror = onError
                xhr.onload = function () {
                    if (xhr.status == 200) {
                        let features = this1.getFormat().readFeatures(xhr.responseText)
                        // if (that.taskStatus.length != 0) {//这种方式不好，应该直接从服务中过滤，待改！
                        //     features = features.filter(feature => {
                        //         if (that.taskStatus.includes(feature.values_.status)) {
                        //             return true;
                        //         }
                        //         return false;
                        //     })
                        // }
                        this1.addFeatures(features)
                    } else {
                        onError()
                    }
                }
                xhr.send()
            }

            let layerParams = await that.getLayerParameters(mUrl, lyrType);

            let lyrArr = []
            let lyr = null
            if (lyrType === 'Image' && srcType === 'TileWMS') {
                lyr = new Image({
                    title: mTitle,
                    name: mName,
                    visible: mVisible,
                    key: mKey,
                    layersForLegend: layerParams.layersForLegend,
                    productDate: mProductDate,
                    source: new TileWMS({
                        url: mUrl,
                        params: {
                            BBOX: layerParams.ext
                        }
                    })
                })
                lyrArr.push(lyr)
            } else if (lyrType === 'Image' && srcType === 'ImageArcGISRest') {
                lyr = new Image({
                    title: mTitle,
                    name: mName,
                    visible: mVisible,
                    key: mKey,
                    layersForLegend: layerParams.layersForLegend,
                    productDate: mProductDate,
                    source: new ImageArcGISRest({
                        url: mUrl,
                        params: {
                            BBOX: layerParams.ext
                        }
                    })
                })
                lyrArr.push(lyr)
            } else if (lyrType === 'Image' && srcType === 'ImageWMS') {
                lyr = new Image({
                    title: mTitle,
                    name: mName,
                    visible: mVisible,
                    key: mKey,
                    layersForLegend: layerParams.layersForLegend,
                    productDate: mProductDate,
                    source: new ImageWMS({
                        url: mUrl,
                        params: {
                            BBOX: layerParams.ext
                        }
                    })
                })
                lyrArr.push(lyr)
            } else if (lyrType === 'Tile' && srcType === 'TileArcGISRest') {
                lyr = new Tile({
                    title: mTitle,
                    name: mName,
                    visible: mVisible,
                    key: mKey,
                    layersForLegend: layerParams.layersForLegend,
                    productDate: mProductDate,
                    source: new TileArcGISRest({
                        url: mUrl,
                        params: {
                            BBOX: layerParams.ext
                        }
                    })
                })
                lyrArr.push(lyr)
            } else if (lyrType === 'Tile' && srcType === 'TileWMS') {
                lyr = new Tile({
                    title: mTitle,
                    name: mName,
                    visible: mVisible,
                    key: mKey,
                    layersForLegend: layerParams.layersForLegend,
                    productDate: mProductDate,
                    source: new TileWMS({
                        // crossOrigin: 'anonymous',
                        url: mUrl,
                        params: {
                            BBOX: layerParams.ext
                        },
                    })
                })
                lyrArr.push(lyr)
            } else if (lyrType === 'Tile' && srcType === 'WMTS') {
                let projStr = mUrl.replace(/.*tileMatrixSet=/i, '');
                let projection = projGet(projStr); // 获取web墨卡托投影坐标系
                let projectionExtent = projection.getExtent(); // web墨卡托投影坐标系的四至
                let width = getWidth(projectionExtent); // web墨卡托投影坐标系的水平宽度，单位米
                let resolutions = []; // 瓦片分辨率
                let matrixIds = [];
                let t = 1;//4326的情况下matrixIds需要-1
                let e = layerParams.ext;
                if (projStr == 'EPSG:900913') {
                    t = 0;
                    e = that.changeBboxFromLonLat(layerParams.ext);//extent参数需要和投影对应
                }
                for (let i = 0; i < 21; i++) {
                    resolutions[i] = width / (256 * Math.pow(2, i));
                    matrixIds[i] = `${projStr}:${i - t}`;
                }
                lyr = new Tile({
                    title: mTitle,
                    name: mName,
                    visible: mVisible,
                    key: mKey,
                    layersForLegend: layerParams.layersForLegend,
                    productDate: mProductDate,
                    BBOX: layerParams.ext,//用经纬度
                    source: new WMTS({
                        // crossOrigin: 'anonymous',
                        url: mUrl,
                        projection: projStr,
                        format: 'image/png',
                        tileGrid: new WMTSTileGrid({
                            extent: e,
                            origin: getTopLeft(projectionExtent),
                            resolutions: resolutions,
                            matrixIds: matrixIds,
                        }),
                    })
                })
                lyrArr.push(lyr)
            } else if (lyrType === 'Tile' && srcType === 'XYZ') {
                let display = true;
                // if (mTitle === "文字标注") {
                //     display = false;
                // }
                if (mTitle === "路网" || mTitle === "卫星" || mTitle === "文字标注" ) {
                    lyr = new Tile({
                        title: mTitle,
                        name: mName,
                        visible: mVisible,
                        key: mKey,
                        displayInLayerSwitcher: display, //在图层面板中不显示
                        source: new XYZ({
                            url: mUrl,
                            params: {
                                BBOX: layerParams.ext
                            }
                        })
                    })
                }
                else {
                    let source = {};
                    if (/(charmingglobe)|(tile\/)|(\{z}\/\{x})/.test(mUrl)) {//一室那边给的url（需要提前将数字改成/{z}/{x}/{-y}）
                        source = new XYZ({
                            projection: that.mapParams.projection,
                            maxZoom: 18,
                            minZoom: 0,
                            url: mUrl,
                        })
                    }
                    else if (/(thSection3)/.test(mUrl)) {//江苏无人机影像那边给的url（需要提前在后面加入/{z}/{x}/{y}.png）
                        source = new XYZ({
                            projection: that.mapParams.projection,
                            maxZoom: 18,
                            minZoom: 0,
                            url: mUrl,
                        })
                    } else {
                        let projStr1;
                        if (/sj3data/.test(mUrl)  && (/gwc/.test(mUrl))) //obs中切片地址
                            projStr1 = (mUrl.match(/EPSG.*?(?=\/)/, ''))[0].replace('%3A', ':');
                        else
                            projStr1 = (mUrl.match(/@.*(?=@)/, ''))[0].replace('@', '').replace('%3A', ':');
                        let projection1 = projGet(projStr1); // 获取web墨卡托投影坐标系
                        let projectionExtent1 = projection1.getExtent(); // web墨卡托投影坐标系的四至
                        // layerParams.ext = [112.8414803, 23.885475500000002, 114.7496885, 25.5244492]
                        let e = layerParams.ext;
                        if (/900913/.test(projStr1))
                            e = that.changeBboxFromLonLat(layerParams.ext);//layerParams.ext以后都是经纬度
                        // e = [124.71, 44.05, 124.75, 44.16]
                        // e = that.changeBboxFromLonLat(e)
                        source = new XYZ({
                            // crossOrigin:'anonymous',
                            projection: projStr1,
                            
                            tileGrid: new TileGrid({
                                extent: e,  //只加载固定范围的瓦片
                                // origin: [-180, -90],//EPSG:4326对应的
                                // origin: [-20037508.34, -20037508.34],//EPSG:3857对应的
                                origin: getBottomLeft(projectionExtent1),  //tms为左下角为原点
                                resolutions: layerParams.resolutions,
                                // resolutions:[156543.033900000, 78271.516950000, 39135.758475000, 19567.879237500, 9783.939618750, 4891.969809375, 2445.984904688, 1222.992452344, 611.496226172, 305.748113086, 152.874056543, 76.437028271, 38.218514136, 19.109257068, 9.554628534, 4.777314267, 2.388657133, 1.194328567, 0.59716428337097171575, 0.298582142]
                            }),
                            //ol 7.1.0使用
                            tileUrlFunction: function (tileCoord) {
                                let z = tileCoord[0];
                                let x = tileCoord[1];
                                let y = tileCoord[2] + 1;
                                return `${mUrl}/${z}/${x}/${-y}.png`
                            },
                            //ol 5.3.3使用
                            // tileUrlFunction: function (tileCoord) {
                            //     let z = tileCoord[0];
                            //     let x = tileCoord[1];
                            //     let y = tileCoord[2];
                            //     return `${mUrl}/${z}/${x}/${y}.png`
                            // },
                            // url:mUrl,
                        })
                    }
                    lyr = new Tile({
                        title: mTitle,
                        name: mName,
                        visible: mVisible,
                        key: mKey,
                        source: source,
                        productDate: mProductDate,
                        layersForLegend: layerParams.layersForLegend,
                        BBOX: layerParams.ext
                        // BBOX: [124.71,44.05,124.75,44.16]
                    })
                }
                lyrArr.push(lyr)
            } else if (lyrType === 'lVector' && srcType === 'Vector') {
                //console.log("此为lVector-Vector类型");
                lyr = new lVector({
                    title: mTitle,
                    name: mName,
                    visible: mVisible,
                    key: mKey,
                    layersForLegend: layerParams.layersForLegend,
                    productDate: mProductDate,
                    params: {
                        BBOX: layerParams.ext
                    },
                    source: new Vector({
                        format: new GeoJSON(),
                        // projection: 'EPSG:4490',
                        projection: that.mapParams.projection,
                        // url: mUrl,

                        loader: vectorLoader
                    }),
                })


                //                 let sld = `<?xml version="1.0" encoding="UTF-8"?>
                // <StyledLayerDescriptor xmlns="http://www.opengis.net/sld" version="1.1.0" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:se="http://www.opengis.net/se" xsi:schemaLocation="http://www.opengis.net/sld http://schemas.opengis.net/sld/1.1.0/StyledLayerDescriptor.xsd" xmlns:ogc="http://www.opengis.net/ogc" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance">
                //   <NamedLayer>
                //     <se:Name>luotu_common_style</se:Name>
                //     <UserStyle>
                //       <se:Name>luotu_common_style</se:Name>
                //       <se:FeatureTypeStyle>
                //         <se:Rule>
                //           <se:Name>未调查</se:Name>
                //           <se:Description>
                //             <se:Title>未调查</se:Title>
                //           </se:Description>
                //           <ogc:Filter xmlns:ogc="http://www.opengis.net/ogc">
                //             <ogc:PropertyIsEqualTo>
                //               <ogc:PropertyName>status</ogc:PropertyName>
                //               <ogc:Literal>30</ogc:Literal>
                //             </ogc:PropertyIsEqualTo>
                //           </ogc:Filter>
                //           <se:PointSymbolizer>
                //             <se:Graphic>
                //               <se:Mark>
                //                 <se:WellKnownName>circle</se:WellKnownName>
                //                 <se:Fill>
                //                   <se:SvgParameter name="fill">#b0f4ff</se:SvgParameter>
                //                 </se:Fill>
                //                 <se:Stroke>
                //                   <se:SvgParameter name="stroke">#b0f4ff</se:SvgParameter>
                //                   <se:SvgParameter name="stroke-width">0.5</se:SvgParameter>
                //                 </se:Stroke>
                //               </se:Mark>
                //               <se:Size>5</se:Size>
                //             </se:Graphic>
                //           </se:PointSymbolizer>
                //         </se:Rule>
                //         <se:Rule>
                //           <se:Name>未审核</se:Name>
                //           <se:Description>
                //             <se:Title>未审核</se:Title>
                //           </se:Description>
                //           <ogc:Filter xmlns:ogc="http://www.opengis.net/ogc">
                //             <ogc:Or>
                //               <ogc:PropertyIsEqualTo>
                //                 <ogc:PropertyName>status</ogc:PropertyName>
                //                 <ogc:Literal>41</ogc:Literal>
                //               </ogc:PropertyIsEqualTo>
                //               <ogc:PropertyIsEqualTo>
                //                 <ogc:PropertyName>status</ogc:PropertyName>
                //                 <ogc:Literal>42</ogc:Literal>
                //               </ogc:PropertyIsEqualTo>
                //             </ogc:Or>
                //           </ogc:Filter>
                //           <se:PointSymbolizer>
                //             <se:Graphic>
                //               <se:Mark>
                //                 <se:WellKnownName>circle</se:WellKnownName>
                //                 <se:Fill>
                //                   <se:SvgParameter name="fill">#f4ad22</se:SvgParameter>
                //                 </se:Fill>
                //                 <se:Stroke>
                //                   <se:SvgParameter name="stroke">#f4ad22</se:SvgParameter>
                //                   <se:SvgParameter name="stroke-width">0.5</se:SvgParameter>
                //                 </se:Stroke>
                //               </se:Mark>
                //               <se:Size>5</se:Size>
                //             </se:Graphic>
                //           </se:PointSymbolizer>
                //         </se:Rule>
                //         <se:Rule>
                //           <se:Name>未整改</se:Name>
                //           <se:Description>
                //             <se:Title>未整改</se:Title>
                //           </se:Description>
                //           <ogc:Filter xmlns:ogc="http://www.opengis.net/ogc">
                //             <ogc:Or>
                //               <ogc:PropertyIsEqualTo>
                //                 <ogc:PropertyName>status</ogc:PropertyName>
                //                 <ogc:Literal>51</ogc:Literal>
                //               </ogc:PropertyIsEqualTo>
                //               <ogc:PropertyIsEqualTo>
                //                 <ogc:PropertyName>status</ogc:PropertyName>
                //                 <ogc:Literal>52</ogc:Literal>
                //               </ogc:PropertyIsEqualTo>
                //             </ogc:Or>
                //           </ogc:Filter>
                //           <se:PointSymbolizer>
                //             <se:Graphic>
                //               <se:Mark>
                //                 <se:WellKnownName>circle</se:WellKnownName>
                //                 <se:Fill>
                //                   <se:SvgParameter name="fill">#fa5b82</se:SvgParameter>
                //                 </se:Fill>
                //                 <se:Stroke>
                //                   <se:SvgParameter name="stroke">#fa5b82</se:SvgParameter>
                //                   <se:SvgParameter name="stroke-width">0.5</se:SvgParameter>
                //                 </se:Stroke>
                //               </se:Mark>
                //               <se:Size>5</se:Size>
                //             </se:Graphic>
                //           </se:PointSymbolizer>
                //         </se:Rule>
                //         <se:Rule>
                //           <se:Name>销号</se:Name>
                //           <se:Description>
                //             <se:Title>销号</se:Title>
                //           </se:Description>
                //           <ogc:Filter xmlns:ogc="http://www.opengis.net/ogc">
                //             <ogc:Or>
                //               <ogc:PropertyIsEqualTo>
                //                 <ogc:PropertyName>status</ogc:PropertyName>
                //                 <ogc:Literal>46</ogc:Literal>
                //               </ogc:PropertyIsEqualTo>
                //               <ogc:PropertyIsEqualTo>
                //                 <ogc:PropertyName>status</ogc:PropertyName>
                //                 <ogc:Literal>56</ogc:Literal>
                //               </ogc:PropertyIsEqualTo>
                //             </ogc:Or>
                //           </ogc:Filter>
                //           <se:PointSymbolizer>
                //             <se:Graphic>
                //               <se:Mark>
                //                 <se:WellKnownName>circle</se:WellKnownName>
                //                 <se:Fill>
                //                   <se:SvgParameter name="fill">#86e945</se:SvgParameter>
                //                 </se:Fill>
                //                 <se:Stroke>
                //                   <se:SvgParameter name="stroke">#86e945</se:SvgParameter>
                //                   <se:SvgParameter name="stroke-width">0.5</se:SvgParameter>
                //                 </se:Stroke>
                //               </se:Mark>
                //               <se:Size>5</se:Size>
                //             </se:Graphic>
                //           </se:PointSymbolizer>
                //         </se:Rule>

                //         <se:Rule>
                //           <se:Name>未调查</se:Name>
                //           <se:MaxScaleDenominator>30000.0</se:MaxScaleDenominator>
                //           <se:Description>
                //             <se:Title>未调查</se:Title>
                //           </se:Description>
                //           <ogc:Filter xmlns:ogc="http://www.opengis.net/ogc">
                //             <ogc:PropertyIsEqualTo>
                //               <ogc:PropertyName>status</ogc:PropertyName>
                //               <ogc:Literal>30</ogc:Literal>
                //             </ogc:PropertyIsEqualTo>
                //           </ogc:Filter>
                //           <se:PolygonSymbolizer>
                //             <se:Fill>
                //               <se:SvgParameter name="fill">#b0f4ff</se:SvgParameter>
                //               <se:SvgParameter name="fill-opacity">0</se:SvgParameter>
                //             </se:Fill>
                //             <se:Stroke>
                //               <se:SvgParameter name="stroke">#b0f4ff</se:SvgParameter>
                //               <se:SvgParameter name="stroke-opacity">1</se:SvgParameter>
                //               <se:SvgParameter name="stroke-width">1</se:SvgParameter>
                //               <se:SvgParameter name="stroke-linejoin">bevel</se:SvgParameter>
                //             </se:Stroke>
                //           </se:PolygonSymbolizer>
                //         </se:Rule>
                //         <se:Rule>
                //           <se:Name>未审核</se:Name>
                //           <se:MaxScaleDenominator>30000.0</se:MaxScaleDenominator>
                //           <se:Description>
                //             <se:Title>未审核</se:Title>
                //           </se:Description>
                //           <ogc:Filter xmlns:ogc="http://www.opengis.net/ogc">
                //             <ogc:Or>
                //               <ogc:PropertyIsEqualTo>
                //                 <ogc:PropertyName>status</ogc:PropertyName>
                //                 <ogc:Literal>41</ogc:Literal>
                //               </ogc:PropertyIsEqualTo>
                //               <ogc:PropertyIsEqualTo>
                //                 <ogc:PropertyName>status</ogc:PropertyName>
                //                 <ogc:Literal>42</ogc:Literal>
                //               </ogc:PropertyIsEqualTo>
                //             </ogc:Or>
                //           </ogc:Filter>
                //           <se:PolygonSymbolizer>
                //             <se:Fill>
                //               <se:SvgParameter name="fill">#f4ad22</se:SvgParameter>
                //               <se:SvgParameter name="fill-opacity">0</se:SvgParameter>
                //             </se:Fill>
                //             <se:Stroke>
                //               <se:SvgParameter name="stroke">#f4ad22</se:SvgParameter>
                //               <se:SvgParameter name="stroke-opacity">1</se:SvgParameter>
                //               <se:SvgParameter name="stroke-width">1</se:SvgParameter>
                //               <se:SvgParameter name="stroke-linejoin">bevel</se:SvgParameter>
                //             </se:Stroke>
                //           </se:PolygonSymbolizer>
                //         </se:Rule>
                //         <se:Rule>
                //           <se:Name>未整改</se:Name>
                //           <se:MaxScaleDenominator>30000.0</se:MaxScaleDenominator>
                //           <se:Description>
                //             <se:Title>未整改</se:Title>
                //           </se:Description>
                //           <ogc:Filter xmlns:ogc="http://www.opengis.net/ogc">
                //             <ogc:Or>
                //               <ogc:PropertyIsEqualTo>
                //                 <ogc:PropertyName>status</ogc:PropertyName>
                //                 <ogc:Literal>51</ogc:Literal>
                //               </ogc:PropertyIsEqualTo>
                //               <ogc:PropertyIsEqualTo>
                //                 <ogc:PropertyName>status</ogc:PropertyName>
                //                 <ogc:Literal>52</ogc:Literal>
                //               </ogc:PropertyIsEqualTo>
                //             </ogc:Or>
                //           </ogc:Filter>
                //           <se:PolygonSymbolizer>
                //             <se:Fill>
                //               <se:SvgParameter name="fill">#fa5b82</se:SvgParameter>
                //               <se:SvgParameter name="fill-opacity">0</se:SvgParameter>
                //             </se:Fill>
                //             <se:Stroke>
                //               <se:SvgParameter name="stroke">#fa5b82</se:SvgParameter>
                //               <se:SvgParameter name="stroke-opacity">1</se:SvgParameter>
                //               <se:SvgParameter name="stroke-width">1</se:SvgParameter>
                //               <se:SvgParameter name="stroke-linejoin">bevel</se:SvgParameter>
                //             </se:Stroke>
                //           </se:PolygonSymbolizer>
                //         </se:Rule>
                //         <se:Rule>
                //           <se:Name>销号</se:Name>
                //           <se:MaxScaleDenominator>30000.0</se:MaxScaleDenominator>
                //           <se:Description>
                //             <se:Title>销号</se:Title>
                //           </se:Description>
                //           <ogc:Filter xmlns:ogc="http://www.opengis.net/ogc">
                //             <ogc:Or>
                //               <ogc:PropertyIsEqualTo>
                //                 <ogc:PropertyName>status</ogc:PropertyName>
                //                 <ogc:Literal>46</ogc:Literal>
                //               </ogc:PropertyIsEqualTo>
                //               <ogc:PropertyIsEqualTo>
                //                 <ogc:PropertyName>status</ogc:PropertyName>
                //                 <ogc:Literal>56</ogc:Literal>
                //               </ogc:PropertyIsEqualTo>
                //             </ogc:Or>
                //           </ogc:Filter>
                //           <se:PolygonSymbolizer>
                //             <se:Fill>
                //               <se:SvgParameter name="fill">#86e945</se:SvgParameter>
                //               <se:SvgParameter name="fill-opacity">0</se:SvgParameter>
                //             </se:Fill>
                //             <se:Stroke>
                //               <se:SvgParameter name="stroke">#86e945</se:SvgParameter>
                //               <se:SvgParameter name="stroke-opacity">1</se:SvgParameter>
                //               <se:SvgParameter name="stroke-width">1</se:SvgParameter>
                //               <se:SvgParameter name="stroke-linejoin">bevel</se:SvgParameter>
                //             </se:Stroke>
                //           </se:PolygonSymbolizer>
                //         </se:Rule>
                //       </se:FeatureTypeStyle>
                //     </UserStyle>
                //   </NamedLayer>
                // </StyledLayerDescriptor>
                // `
                //                 that.applySLD(lyr, sld);

                lyrArr.push(lyr);
            } else if (lyrType === 'lVector' && srcType === 'Cluster') {
                //console.log("此为lVector-Cluster类型");
                let vectorSource = new Vector({
                    format: new GeoJSON(),
                    // projection: 'EPSG:4490',
                    projection: that.mapParams.projection,
                    loader: vectorLoader,
                })
                let tempResolution = that.cluResolution;
                let tempDistance = that.cluDistance;
                lyr = new lVector({
                    title: mTitle,
                    name: mName,
                    visible: mVisible,
                    //extent:mExtent, //左下点-右上点
                    minResolution: tempResolution,
                    key: mKey,
                    layersForLegend: layerParams.layersForLegend,
                    productDate: mProductDate,
                    params: {
                        BBOX: layerParams.ext
                    },
                    source: new Cluster({
                        distance: tempDistance,
                        source: vectorSource,
                        geometryFunction: function (feature) {
                            //获取多边形内点的方法
                            let geom = feature.getGeometry()
                            if (geom instanceof Polygon) {
                                return feature.getGeometry().getInteriorPoint()
                            } else if (geom instanceof MultiPolygon) {
                                return feature.getGeometry().getInteriorPoints().getPoint(0)
                            }
                        }
                    }),
                    style: styleFunction
                })
                lyrArr.push(lyr)

                let lyr1 = new lVector({
                    title: mTitle,
                    name: mName,
                    visible: mVisible,
                    displayInLayerSwitcher: false, //在图层面板中不显示
                    maxResolution: tempResolution,
                    key: mKey,
                    layersForLegend: layerParams.layersForLegend,
                    productDate: mProductDate,
                    params: {
                        BBOX: layerParams.ext
                    },
                    source: new Vector({
                        format: new GeoJSON(),
                        projection: 'EPSG:4490',
                        // url: mUrl,
                        params: {
                            BBOX: layerParams.ext
                        },
                        loader: vectorLoader
                    })
                })
                lyrArr.push(lyr1)
            } else if (lyrType === 'Tile' && srcType === 'OSM') {
                lyr = new Tile({
                    title: mTitle,
                    name: mName,
                    visible: mVisible,
                    key: mKey,
                    source: new OSM()
                })
                lyrArr.push(lyr)
            } else if (lyrType === 'VectorTile' && srcType === 'VectorTile') {//矢量切片，后续需要获取属性，待研究
                lyr = new lVectorTile({
                    title: mTitle,
                    name: mName,
                    visible: mVisible,
                    key: mKey,
                    layersForLegend: layerParams.layersForLegend,
                    BBOX: layerParams.ext,
                    projection: that.mapParams.projection,
                    source: new VectorTile({
                        format: new MVT(),
                        tilePixelRatio: 1, // oversampling when > 1
                        tileGrid: createXYZ({ extent: projGet(that.mapParams.projection).getExtent(), maxZoom: 22 }),
                        url: mUrl + '/{z}/{x}/{-y}.pbf'
                    })
                })
                that.applySLD(lyr, layerParams.sld);//根据读取到的sld文件给图层配色
                lyrArr.push(lyr)
            } 
            else if (lyrType === 'pyTile' && srcType === 'XYZ') {//江苏无人机影像那边给的url（需要提前在后面加入/{z}/{x}/{y}.png）
                let projection1 = projGet(that.mapParams.projection); // 获取web墨卡托投影坐标系
                let projectionExtent1 = projection1.getExtent(); // web墨卡
                let e = that.changeBboxFromLonLat(layerParams.ext);//layerParams.ext以后都是经纬度
                let source = new XYZ({
                    projection: that.mapParams.projection,
                    tileGrid: new TileGrid({
                        extent: e,
                        origin: getBottomLeft(projectionExtent1),  //tms为左下角为原点
                        //resolutions: layerParams.resolutions,
                        resolutions:[156543.033900000, 78271.516950000, 39135.758475000, 19567.879237500, 9783.939618750, 4891.969809375, 2445.984904688, 1222.992452344, 611.496226172, 305.748113086, 152.874056543, 76.437028271, 38.218514136, 19.109257068, 9.554628534, 4.777314267, 2.388657133, 1.194328567, 0.59716428337097171575, 0.298582142]
                    }),
                    tileUrlFunction: function (tileCoord) {
                        let z = tileCoord[0];
                        let x = tileCoord[1];
                        let y = tileCoord[2] + 1;
                        return `${mUrl}/${z}/${x}/${-y}.png`
                    },
                    maxZoom: 15,
                    minZoom: 0,
                })
                //WebGLTile 会出现黑边
                lyr = new Tile({
                    title: mTitle,
                    name: mName,
                    visible: mVisible,
                    key: mKey,
                    source: source,
                    productDate: mProductDate,
                    layersForLegend: layerParams.layersForLegend,
                    BBOX: layerParams.ext
                })
                lyrArr.push(lyr);
            }else if (lyrType === 'Group') {
                let lG = []
                for (let i = 0; i < mSubLayers.length; i++) {
                    let lyr4tmps = null
                    lyr4tmps = await that.addLyr4init(mSubLayers[i])
                    lyr4tmps.forEach(value => {
                        lG.push(value)
                    })
                }
                lyr = new Group({
                    title: mTitle,
                    visible: mVisible,
                    layers: lG
                })
                lyrArr.push(lyr)
            } else {
                console.log('抱歉，地图资源类型不明，请检查并重试，或联系管理员协助解决。')
            }
            return lyrArr
        },

        //根据url调用接口获取extent，图例，tms的resolutions
        async getLayerParameters(mUrl, lyrType) {
            let that = this;
            let ext = [];
            let layersForLegend = [];
            let resolutions = [];
            let sld = '';
            let isVectorTile = false;
            if (/sj3data/.test(mUrl) && (/gwc/.test(mUrl))) {//obs中切片地址，目前都是内网geoserver切出来的，直接去找参数即可
                let projStr = (mUrl.match(/EPSG.*?(?=\/)/, ''))[0];
                let layerStr = (mUrl.match(/gwc\/.*?(?=\/)/, ''))[0].replace('gwc/', '');
                let ip = that.isOutNet ? '121.36.101.27' : '192.168.103.72';//都是内网geoserver
                mUrl = `http://${ip}:3000/geoserver/gwc/service/tms/1.0.0/${layerStr}@${projStr}@png`
            }
            if (/geoserver/i.test(mUrl)) {
                // let parser = new WMSCapabilities();
                let ws = '';
                let name = '';
                let tURL = mUrl;
                // let tempURL = mUrl;
                if (/(wmts|wfs)/i.test(tURL)) {//通过wms的方式获取相关参数，其他服务其实也可以这么改，待改！
                    let s = tURL.match(/(layers|layer|typeName)=.+?(?=&)/i);
                    s[0] = s[0].split("=")[1];
                    tURL = `${tURL.replace(/geoserver.*/, '')}geoserver/${s[0].replace(/\:.*/, '')}/wms?service=WMS&version=1.1.0&request=GetMap&layers=${s[0]}&styles=`; // eslint-disable-line
                }
                if (/tms/i.test(tURL)) {
                    let layerName = tURL.split('/');
                    layerName = layerName[layerName.length - 1].split('@')[0];
                    ws = layerName.split('%')[0];
                    layerName = layerName.replace('%3A', ':');

                    if (/pbf/i.test(tURL)) //pbf格式的矢量切片
                        isVectorTile = true

                    let parserForTMS = new DOMParser(); //解析xml或者html\
                    resolutions = await that.axios({ url: tURL }).then(function (response) {
                        let xmlDoc = parserForTMS.parseFromString(response.data, "text/xml"); //解析xml或者html
                        //提取数据 
                        let tileSets = xmlDoc.getElementsByTagName('TileSets')[0].children;
                        for (const t of tileSets) {
                            resolutions.push(t.attributes['units-per-pixel'].nodeValue);
                        }
                        return resolutions;//如果不执行的话，async内部await后面的函数不执行，直接 执行async（异步）后面的代码
                    }).catch(function (error) {
                        console.log(error)
                    })
                    tURL = `${tURL.split('gwc')[0] + ws}/wms?service=WMS&version=1.1.0&request=GetMap&layers=${layerName}&styles=`;
                }
                if (/GetMap/i.test(tURL)) {
                    tURL = tURL.replace(/GetMap/i, 'GetCapabilities');
                    tURL.split("?")[1].split("&").forEach(value => {
                        if (/(LAYERS|typeName)=.+?/i.test(value)) {
                            name = value;
                        }
                    })
                    name = name.split("=")[1];
                    that.featureTypesForAttr.push(name);
                    ws = name.split(":")[0];
                    name = name.split(":")[1];
                    //获取工作区单一图层得范围和图例参数
                    let tURL1 = tURL.split("wms?")[0];
                    let tURL2 = tURL1 + name + `/wms?` + tURL.split("wms?")[1]
                    if (name) {
                        let layerStyleURL = '';
                        [ext, layersForLegend] = await that.axios({ url: tURL2 }).then(function (response) {
                            let result = JSON.parse(xml2Json.xml2json(response.data, { compact: true, spaces: 4 }));
                            //工作区内就一个图层会出错  主要因为单个图层会变成对象
                            // if(result.WMT_MS_Capabilities.Capability.Layer.Layer.length){
                            //     result.WMT_MS_Capabilities.Capability.Layer.Layer.forEach(layer => {
                            //         if (layer.Name._text === name) {
                            //             let latLonBoundingBox = layer.LatLonBoundingBox._attributes;
                            //             ext = [Number(latLonBoundingBox.minx), Number(latLonBoundingBox.miny), Number(latLonBoundingBox.maxx), Number(latLonBoundingBox.maxy)];
                            //             if (layer.Name._text != 'JiLinShp' && layer.Style) {
                            //                 layersForLegend.push(layer.Style.LegendURL);
                            //                 if (isVectorTile) {//矢量切片需要获取sld，其实普通矢量也需要，暂不考虑
                            //                     let styleName = layer.Style.Name._text;
                            //                     let baseurl = tURL.replace(/geoserver.*/, '');
                            //                     if (/\:/.test(styleName)) 
                            //                         layerStyleURL = `${baseurl}geoserver/rest/workspaces/${styleName.split(":")[0]}/styles/${styleName.split(":")[1]}.sld`;
                            //                     else 
                            //                         layerStyleURL = `${baseurl}geoserver/rest/styles/${styleName}.sld`;  
                            //                 }
                            //             }
                            //         }
                            //     })
                            // }else{
                            let layer = result.WMT_MS_Capabilities.Capability.Layer.Layer;
                            //if (layer.Name._text === name) {
                            let latLonBoundingBox = layer.LatLonBoundingBox._attributes;
                            ext = [Number(latLonBoundingBox.minx), Number(latLonBoundingBox.miny), Number(latLonBoundingBox.maxx), Number(latLonBoundingBox.maxy)];
                            if (layer.Name._text != 'JiLinShp' && layer.Style) {
                                layersForLegend.push(layer.Style.LegendURL);
                                if (isVectorTile) {//矢量切片需要获取sld，其实普通矢量也需要，暂不考虑
                                    //console.log(layer)
                                    let styleName = layer.Style.Name._text;
                                    let baseurl = tURL.replace(/geoserver.*/, '');
                                    if (/\:/.test(styleName))  // eslint-disable-line
                                        layerStyleURL = `${baseurl}geoserver/rest/workspaces/${styleName.split(":")[0]}/styles/${styleName.split(":")[1]}.sld`;
                                    else
                                        layerStyleURL = `${baseurl}geoserver/rest/styles/${styleName}.sld`;
                                }
                            }
                            //}
                            //}


                            return [ext, layersForLegend];//如果不执行的话，async内部await后面的函数不执行，直接执行async（异步）后面的代码
                        })
                            .catch(function (error) {
                                console.log(error)
                            })

                        if (isVectorTile) {//矢量切片需要获取sld，其实普通矢量也需要，暂不考虑
                            let config = {
                                method: 'get',
                                url: layerStyleURL,
                                headers: {
                                    'accept': 'application/vnd.ogc.se+xml',
                                    'content-type': 'application/json'
                                },
                                auth: that.geoserverAuth,
                            };
                            sld = await that.axios(config)
                                .then(response => {
                                    return response.data;
                                })
                                .catch(error => {
                                    console.error('查询sld出错');
                                });
                        }
                    }
                }
            } else if (/arcgis/i.test(mUrl)) {
                let tempURL = mUrl + '?f=json';
                await that.axios({ url: tempURL }).then(function (response) {
                    let fExt = response.data.fullExtent;
                    if (fExt.spatialReference.wkid == 4490 || fExt.spatialReference.wkid == 4326) {
                        ext = [fExt.xmin, fExt.ymin, fExt.xmax, fExt.ymax]
                    }
                    Promise.resolve(ext);//如果不执行的话，async内部await后面的函数不执行，直接执行async（异步）后面的代码
                })
                    .catch(function (error) {
                        console.log(error)
                    })

                tempURL = mUrl + '/legend?f=json';
                await that.axios({ url: tempURL }).then(function (response) {
                    // console.log(response.data)
                    layersForLegend = response.data;
                    Promise.resolve(layersForLegend);//如果不执行的话，async内部await后面的函数不执行，直接执行async（异步）后面的代码
                })
                    .catch(function (error) {
                        console.log(error)
                    })
            } else if (/(charmingglobe)|(tile\/)/i.test(mUrl)) {//一室那边给的影像，获取extent，不是所有的都可以，等测试到有问题的再改
                let productId = mUrl.match(/(?<=dataset\/).+?(?=\/)/i) || mUrl.match(/(?<=china1m_).+?(?=\/)/i) || mUrl.match(/(?<=wrj2png\/).+?(?=\/)/i);
                if (productId) {
                    productId = productId[0];
                    let tUrl = `http://119.3.213.94/highmanage/seniorProductMgr/getProductServiceDetailById?productId=${productId}`;
                    // let tUrl = `http://manage.charmingglobe.com/highmanage/seniorProductMgr/getProductServiceDetailById?productId=${productId}`;
                    // let tUrl = `https://manage.charmingglobe.com/highmanage/datasetProduct/getProductServiceDetailById?productId=${productId}`;
                    if (!that.isOutNet) {
                        tUrl = tUrl.replace('http://119.3.213.94/highmanage', 'http://10.10.100.7:7171');
                    }
                    await that.axios({ url: tUrl }).then(function (response) {
                        if(response.data.data){
                            let geo = response.data.data.geoJson;
                            // geo = JSON.parse(geo);
                            if (geo.type == 'Polygon') {
                                ext = new Polygon(geo.coordinates).getExtent();
                            }
                        }else{
                            ext =[121.63489450500003,40.860237109000025,131.3137969770001,46.302589080000075]
                        }
                        
                        Promise.resolve(ext);//如果不执行的话，async内部await后面的函数不执行，直接执行async（异步）后面的代码
                    })
                        .catch(function (error) {
                            console.log(error)
                        })
                }
            } else if (/(jl1mall)/i.test(mUrl)) {
        let mk = mUrl.match(/mk=(\S*)&tk/)[1]; //获取url layers到&styles中间部分
        let pro = mUrl.match(/pro=(\S*)/)[1]; //获取url layers到&styles中间部分
        if (mk && pro) {
          let param=new FormData();
            param.append('program_id',pro);
            param.append('mk',mk);
          await this.axios
                .post("/map_service_back/program/getExtentByProgram", param,{
                  headers: {
                    Authorization: "Bearer " + this.getKey(),
                  },
                }).then((response) => {
                    if(response.data.code == 500){
                        ext = [73.66, 3.86, 135.05, 53.55]
                        that.$message.warning(response.data.message);
                    }else if (response.data.data) {
                        let extOld = response.data.data
                        extOld = extOld.split(',')
                        ext = [parseFloat(extOld[0]),parseFloat(extOld[1]),parseFloat(extOld[2]),parseFloat(extOld[3])]
                    } else {
                        ext = [73.66, 3.86, 135.05, 53.55]
                    }
              Promise.resolve(ext) //如果不执行的话，async内部await后面的函数不执行，直接执行async（异步）后面的代码
                })
          
            .catch(function(error) {
              console.log(error)
            })
        }
      }else if ((lyrType == 'GeoTIFFOne') || (lyrType == 'GeoTIFFThree')) {
                //geotiff
                let nameAll = mUrl.split('/')
                let name = nameAll[nameAll.length - 1].split('.')[0];
                let type = nameAll[nameAll.length - 2];
                await that.axios({ url: `http://sj3data.obs.cn-north-4.myhuaweicloud.com/data/cog/${type}/${name}.json` })
                    .then(function (response) {
                        let extArr = response.data.split(',')
                        if(/py/.test(type)){
                            ext = [parseFloat(extArr[0].slice(1,extArr[0].length-1)), parseFloat(extArr[1]), parseFloat(extArr[2]), parseFloat(extArr[3])]
                            let center1= [ext[0],ext[1]]
                            let center2= [ext[2],ext[3]]
                            ext = [toLonLat(center1)[0],toLonLat(center1)[1],toLonLat(center2)[0],toLonLat(center2)[1]]
                        }else{
                            ext = [parseFloat(extArr[0]), parseFloat(extArr[1]), parseFloat(extArr[2]), parseFloat(extArr[3])]
                        }
                        Promise.resolve(ext); //如果不执行的话，async内部await后面的函数不执行，直接执行async（异步）后面的代码
                    })
                    .catch(function (error) {
                        console.log(error);
                    });

                if ((lyrType == 'GeoTIFFOne')) {
                    //获取样式表
                    await that.axios({ url: `http://sj3data.obs.cn-north-4.myhuaweicloud.com/data/cog/${type}/style/${name}.json` })
                        .then(function (response) {
                            that.tyStyle = response.data
                            layersForLegend.push(response.data.legend)
                            Promise.resolve(layersForLegend); //如果不执行的话，async内部await后面的函数不执行，直接执行async（异步）后面的代码
                        })
                        .catch(function (error) {
                            layersForLegend.push('http://sj3data.obs.cn-north-4.myhuaweicloud.com/data/cog/jieguo/style/test_fenlei_out.png')
                            // that.tyStyle = ty_style
                        })
                }
            }else if ((lyrType == 'pyTile')) {
                //geotiff
                let nameAll = mUrl.split('/')
                let name = nameAll[nameAll.length - 1].split('.')[0];
                await that.axios({ url: `http://sj3data.obs.cn-north-4.myhuaweicloud.com/data/pyTiles/${name}/tilemapresource.xml` })
                    .then(function (response) {
                        let result = JSON.parse(xml2Json.xml2json(response.data, { compact: true, spaces: 4 }));
                        ext = [parseFloat(result.TileMap.BoundingBox._attributes.minx), parseFloat(result.TileMap.BoundingBox._attributes.miny), parseFloat(result.TileMap.BoundingBox._attributes.maxx), parseFloat(result.TileMap.BoundingBox._attributes.maxy)]
                        //提取数据 
                        let tileSets = result.TileMap.TileSets.TileSet
                        for (const t of tileSets) {
                            resolutions.push(parseFloat(t._attributes['units-per-pixel']));
                        }
                        // console.log(resolutions)
                        Promise.resolve(ext); //如果不执行的话，async内部await后面的函数不执行，直接执行async（异步）后面的代码
                        Promise.resolve(resolutions); 
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }

            return { ext, layersForLegend, resolutions, sld };
        },
        getKey() {
            return localStorage.getItem("token");
          },

    //缩放至功能坐标转换
    changeBboxFromLonLat(ext) {
        let p1 = [ext[0], ext[1]];
        let p2 = [ext[2], ext[3]];
        p1 = fromLonLat(p1);
        p2 = fromLonLat(p2);
        return [p1[0], p1[1], p2[0], p2[1]];
    },
    //缩放至功能
    zoomToExtent(layer) {
            let ext = [];
            // let projection = layer.getSource().getProjection();
            if (layer.getSource() instanceof Vector || layer.getSource() instanceof Cluster) {//这里等处理完这俩类型之后再改
                ext = layer.values_.params.BBOX;
            } else if (layer.getSource() instanceof XYZ || layer.getSource() instanceof WMTS || layer.getSource() instanceof VectorTile) {
                // ext=layer.getSource().tileGrid.extent_;
                ext = layer.values_.BBOX;
            } else {
                ext = layer.getSource().params_.BBOX;
            }
            
            if (ext && ext.length > 0) {
                //如果是EPSG:4326（WMS的要求都是4326或4490的数据源，且WMS的服务projection应该都是null，切片的有可能是4326的）或者是一室给的服务，得调用changeBboxFromLonLat
                // if (!projection || projection.code_ === "EPSG:4326" || /(charmingglobe)|(tile\/)/i.test(layer.getSource().urls[0])) {
                //     debugger
                    ext = this.changeBboxFromLonLat(ext);
                // }
                this.map.getView().fit(ext)
            }
        },
    //cusType指绘制的图形  type指绘制结束后的操作
    extentDraw(cusType){
        let that = this;
        this.source.clear();
        this.map.removeInteraction(this.draw);
        if(cusType == 'cusJuxing'){
            this.addInteraction(cusType);
        }
        
    },
    addInteraction(drawType){
        let that = this;
        if(drawType != 'None'){
            if(drawType == 'cusJuxing'){
                this.draw = new Draw({
                    //绘制对象
                    source: that.source, //绘制层数据源,勾绘的要素属于的数据集
                    // type: /** @type {ol.geom.GeometryType} */(value), //几何图形类型   //矩形对应 Circle
                    type: 'Circle',
                    style: new Style({
                        fill: new Fill({
                            color: 'rgba(255,255,255,0.2)'
                        }),
                        stroke: new Stroke({
                            color: '#ffcc33',
                            width: 2
                        }),
                        image: new Circle({
                            radius: 7,
                            fill: new Fill({
                                color: '#ffcc33'
                            })
                        })
                    }),
                    geometryFunction: createBox()   //绘制矩形 
                })
            }else if(drawType == 'cusSquare'){
                this.draw = new Draw({
                    //绘制对象
                    source: that.source, //绘制层数据源,勾绘的要素属于的数据集
                    // type: /** @type {ol.geom.GeometryType} */(value), //几何图形类型   //矩形对应 Circle
                    type: 'Circle',
                    style: new Style({
                        fill: new Fill({
                            color: 'rgba(255,255,255,0.2)'
                        }),
                        stroke: new Stroke({
                            color: '#ffcc33',
                            width: 2
                        }),
                        image: new Circle({
                            radius: 7,
                            fill: new Fill({
                                color: '#ffcc33'
                            })
                        })
                    }),
                    geometryFunction: createRegularPolygon(4)   //绘制矩形 
                }) 
            }
            this.map.addInteraction(this.draw);
            this.draw.on('drawend', (evt)=>{
                this.map.removeInteraction(this.draw);
                let geom = evt.feature.getGeometry();
                this.imageGeo = new GeoJSON().writeGeometry(geom,{dataProjection:'EPSG:4326',featureProjection:'EPSG:3857'});
                let that = this;
                let ft = evt.feature;
                let format = new GeoJSON();
                let obj = JSON.parse(format.writeFeature(ft));
                let newCoordinates = [];
                let coordinates = obj.geometry.coordinates[0];
                for (let i = 0; i < coordinates.length; i++) {
                    newCoordinates.push(toLonLat(coordinates[i]))
                }
                let longArr=[];
                let latArr=[];
                for(let i = 0; i < newCoordinates.length; i++){
                    longArr.push(newCoordinates[i][0])
                    latArr.push(newCoordinates[i][1])
                }
                that.tifExtent = [Math.min(...longArr),Math.min(...latArr),Math.max(...longArr),Math.max(...latArr)];
            });
        }
    },

    }
  }
</script>

<style scoped>
  @import '~ol-ext/dist/ol-ext.css';
  @import '../../assets/mapIcon/mapctrl/my-ol-ext.css';
  @import url('../../assets/less/mainMap.less');
</style>

<style>
  @import url('../../assets/less/customOl.less');
</style>